import { useTypedLocation } from "./useTypedLocation";

export type TabKind = "transport" | "trips" | "hotels";

/** Determine which tab you are looking at. E.g. transport, trips or hotels */
export function useTabKind(): TabKind {
  const location = useTypedLocation();
  const parts = location.hash.slice(1).split("/");
  if (parts.includes("h")) return "hotels";
  if (parts.includes("trips")) return "trips";
  return "transport";
}
